<template>
	<div class="view" v-if="loaded">
		<div class="top">
			<uiInput class="title" v-model="title" placeholder="Название статьи" />
			<uiDropdown
				:options="petKinds"
				optionsLabel="title"
				:value="petKind"
				label="Для кого статья"
				@input="setPetKind"
				style="margin-top: 10px;"
			/>
		</div>

		<Editor ref="editor" :blocks="blocks" @save="save" :loading="loading" />

		<!-- <div class="more">
			<uiInput
				v-model="moreTitle"
				label="Заголовок связанных статей"
				style="margin-bottom: 20px"
			/>
			<uiDropdown
				:options="availableArticles"
				optionsLabel="title"
				v-model="selected"
				label="Связанные статьи"
				@input="addArticle"
			/>
			<draggable
				v-model="more"
				class="rows"
				handle=".handle"
				ghost-class="ghost"
				:forceFallback="true"
			>
				<div class="row" v-for="a in moreArticles" :key="a.id">
					<uiCard class="article handle">
						{{ a.title }}
					</uiCard>
					<div class="trash" @click="removeArticle(a)">
						<i class="lni lni-trash" />
					</div>
				</div>
			</draggable>
		</div> -->
	</div>
	<div class="loader" v-else>
		<uiLoader class="icon" />
	</div>
</template>

<script>
import Draggable from 'vuedraggable'
import translit from 'cyrillic-to-translit-js'
import Editor from '@/components/ArticleEditor'
import { API } from '@/config'
import { difference } from 'lodash'

export default {
	name: 'ArticlePage',
	components: {
		Editor,
		Draggable,
	},
	props: {
		id: String,
	},
	data() {
		return {
			loaded: false,
			loading: false,
			title: '',
			url: '',
			blocks: [],
			more: [],
			moreTitle: '',
			changed: false,
			selected: '',
			kind: 'any',
			petKinds: [
				{ value: 'any', title: 'Для всех' },
				{ value: 'dog', title: 'Для собак' },
				{ value: 'cat', title: 'Для кошек' },
			],
		}
	},
	computed: {
		articleValid() {
			return this.title.length > 0 //&& this.category
		},
		articles() {
			return this.$store.getters.articles
		},
		availableArticles() {
			return this.articles.filter((a) => {
				return !this.more.includes(a.id) && a.id !== this.id
			})
		},
		moreArticles() {
			return this.more.map((id) => {
				return this.articles.find((a) => a.id === id)
			})
		},
		isNewArticle() {
			return this.id === 'new'
		},
		petKind() {
			return this.petKinds.find((k) => k.value === this.kind)
		},
	},
	activated() {
		this.loadArticle()
	},
	deactivated() {
		this.loaded = false
	},
	methods: {
		async loadArticle() {
			if (this.id === 'new') {
				this.title = ''
				this.loaded = true
				return
			}
			let { data } = await this.$http.get(API.ARTICLES.get + this.id)
			if (!data || data.err) return this.$notify(data.err)

			this.title = data.title
			this.url = data.url
			this.blocks = data.blocks
			this.kind = data.kind || 'any'
			this.moreTitle = data.moreTitle || ''
			this.more = data.more || []

			await this.$nextTick()
			this.loaded = true
		},
		addArticle(e) {
			this.more.unshift(e.id)
			this.selected = ''
		},
		removeArticle(e) {
			let ind = this.more.findIndex((id) => id === e.id)
			this.more.splice(ind, 1)
		},
		setPetKind(e) {
			this.kind = e.value
		},
		async save(blocks) {
			if (this.loading) return
			this.loading = true

			let imagesToSave = []
			blocks.map((b, i) => {
				if (b.type === 'image' && b.data.file) {
					imagesToSave.push({ index: i, file: b.data.file })
				}
			})

			if (imagesToSave.length) {
				let promises = imagesToSave.map((i) => this.uploadImage(i))
				let results = await Promise.all(promises)

				if (!results) return this.$notify('Не смогли залить картиночки')
				results.forEach((r) => {
					let fresh = { type: 'image', data: { url: r.url } }
					blocks.splice(r.index, 1, fresh)
				})
			}

			this.blocks = blocks

			if (!this.url) {
				let url = translit().transform(this.title, '-')
				url = url.replace('?', '')
				this.url = url
			}

			let payload = {
				id: this.id,
				title: this.title,
				url: this.url,
				blocks: this.blocks,
				kind: this.kind,
				more: this.more,
				moreTitle: this.moreTitle,
			}

			let { data } = await this.$http.post(API.ARTICLES.update, payload)
			this.loading = false

			if (!data || data.err) return this.$notify(data.err)
			this.changed = false

			this.$store.commit('updateInArray', { path: 'articles', data: data })

			if (this.id === 'new') {
				this.$router.replace('/articles/' + data.id)
				this.$nextTick(() => this.loadArticle())
			}
		},
		async uploadImage(payload) {
			if (this.uploading) return
			this.uploading = true

			let file = null

			await fetch(payload.file).then(async (r) => {
				let blob = await r.blob()
				file = new File([blob], 'temp' + Date.now(), { type: blob.type })
			})

			if (!file) return

			let form = new FormData()
			form.append('file', file)
			form.append('path', 'articles/')

			let { data } = await this.$http.upload(API.SPACES.upload, form)
			if (!data || data.err) {
				this.$notify(data.err)
				return (this.uploading = false)
			}

			return { index: payload.index, url: data.url }
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.loader {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;

	.icon {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
}

.view {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}

.top {
	margin-top: 80px;
	margin-bottom: 30px;

	.url {
		margin-top: 5px;
		color: rgba(0, 0, 0, 0.3);
	}

	.title {
		width: 100%;
	}

	.title /deep/ input {
		font-size: 20px !important;
		font-weight: bold !important;
	}

	.button {
		width: 140px;
		margin: 0;
		margin-left: 20px;
	}
}

.more {
	min-height: 50px;
	margin-bottom: 200px;
}

.rows {
	margin-top: 20px;
}

.row {
	margin-bottom: 15px;
	position: relative;

	.trash {
		width: 50px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		opacity: 0.3;
		font-size: 24px;
		position: absolute;
		top: 0;
		right: -50px;
		cursor: pointer;
	}

	.trash:hover {
		opacity: 1;
	}

	.article {
		font-weight: bold;
		cursor: pointer;
	}
}
</style>
